var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 =
    _vm.detail.is_auto != 0 && _vm.hasTab && _vm.detail.list != ""
      ? _vm.__map(_vm.detail.list, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var m0 = _vm.getRoute()
          var m1 = _vm.getRoute()
          var m2 = _vm.detail.type != 2 ? _vm.getRoute() : null
          var m3 = _vm.detail.type != 1 ? _vm.getRoute() : null
          return {
            $orig: $orig,
            m0: m0,
            m1: m1,
            m2: m2,
            m3: m3,
          }
        })
      : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }